/*
 * @Descripttion: 
 * @version: 
 * @Author: cyf
 * @Date: 2020-11-05 09:28:45
 * @LastEditors: cyf
 * @LastEditTime: 2020-11-05 09:53:08
 */

export const menuRouteMixin = {

  methods: {
    //路由到path，target是_blank时打开新标签
    toLink(path, target) {
      if (path && path != "#") {
        switch (target) {
          case "main":
            if (!path.startsWith("#"))
              this.$router.push(path);
            break;
          case "_blank":
            window.open(path, "_blank");
            break;
          default:
            this.$router.push(path);
            break;
        }
      }
    },
  }
}